import React from 'react';

import {IAddressAttributesProps} from './IAddressAttributes';

const AddressAttributes = ({address}: IAddressAttributesProps) => {
	return (
		<div className="address__attributes">
			<span className="address__addressCity">{address.city}</span>
			<span className="address__addressId">{address.addressId}</span>
			<span className="address__item">{address.fullName}</span>
			<span className="address__item">{address.address1}</span>
			<span className="address__item">{address.address2}</span>
			<span className="address__item">{address.postalCode}</span>
			<span className="address__item">
				{address.city} {address.stateCode}
			</span>
			<span className="address__item">{address.countryCode}</span>
			<span className="address__item">
				{address.phoneCode} {address.phone}
			</span>
			{address.countryCode === 'KR' && <div className="address__item">{address.c_persCustClearenceCode}</div>}
		</div>
	);
};

export default AddressAttributes;
